<template>
  <section class="investor-guide reveal animate-up">
    <div class="container">
      <div class="investor-header">
        <span class="tag-alt">Strategy</span>
        <h2>Investors – A Complete Guide</h2>
      </div>

      <div class="investor-intro-box">
        <div class="intro-text">
          <div class="card-head-line">
            <h3>1. Who is a Real Estate Investor?</h3>
          </div>
          <p>
            A real estate investor purchases property with the primary goal of
            generating
            <strong
              >Rental income, Capital appreciation, Passive cash flow, and
              Portfolio diversification.</strong
            >
            Unlike homebuyers, investors focus more on numbers than emotions.
          </p>
        </div>
      </div>

      <div class="investor-sections">
        <div class="investor-card">
          <div class="card-head-line">
            <h3>2. Types of Real Estate Investors</h3>
          </div>
          <div class="type-sub-grid">
            <div class="type-item">
              <strong>Long-Term Appreciation:</strong> Buy in developing areas
              (Growth corridors like Tricity); hold for 5–10+ years.
            </div>
            <div class="type-item">
              <strong>Rental Income:</strong> Focus on steady monthly returns
              (India avg: 2–4% residential).
            </div>
            <div class="type-item">
              <strong>Flippers:</strong> Buy undervalued, renovate, and sell
              within 6–24 months. <em>Requires strong market timing.</em>
            </div>
            <div class="type-item">
              <strong>Commercial:</strong> SCOs, office spaces, and retail shops
              with higher yields (5–9%).
            </div>
          </div>
        </div>

        <div class="investor-card">
          <div class="card-head-line">
            <h3>3. What Smart Investors Evaluate</h3>
          </div>
          <ul class="investor-list">
            <li>
              <strong>Growth Potential:</strong> Upcoming highways, IT parks,
              and Master plans.
            </li>
            <li>
              <strong>ROI & Yield:</strong> Rental yield %, appreciation trends,
              and exit liquidity.
            </li>
            <li>
              <strong>Compliance:</strong> Verify RERA registration and clear
              legal titles.
            </li>
            <li>
              <strong>Risk Assessment:</strong> Market saturation, builder
              credibility, and interest rates.
            </li>
          </ul>
        </div>
      </div>

      <div class="mindset-section">
        <h3>4. Investor Mindset vs End-User Mindset</h3>
        <div class="table-wrapper">
          <table class="comparison-table">
            <thead>
              <tr>
                <th>Investor Focus</th>
                <th>End-User Focus</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>ROI (Return on Investment)</td>
                <td>Comfort & Lifestyle</td>
              </tr>
              <tr>
                <td>Future Growth Potential</td>
                <td>Present Amenities</td>
              </tr>
              <tr>
                <td>Rental Demand</td>
                <td>Personal Preferences</td>
              </tr>
              <tr>
                <td>Exit Strategy</td>
                <td>Long-term Living</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="mistakes-grid">
        <div class="mistakes-header">
          <h3>5. Common Mistakes to Avoid</h3>
        </div>
        <div class="mistakes-list">
          <span class="mistake-tag">Buying based on hype</span>
          <span class="mistake-tag">Ignoring rental demand</span>
          <span class="mistake-tag">Over-leveraging loans</span>
          <span class="mistake-tag">Not calculating net ROI</span>
          <span class="mistake-tag">Emotional decision-making</span>
        </div>
      </div>

      <div class="golden-rule-banner">
        <p>
          <strong>6. Golden Rule:</strong> Numbers first. Emotions later. If the
          numbers don't make sense, the investment doesn't make sense.
        </p>
      </div>
    </div>
  </section>
</template>

<style scoped>
.investor-guide {
  padding: 100px 0;
  background: #111;
  color: #fff;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.investor-header {
  margin-bottom: 60px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tag-alt {
  color: #b91c1c;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 0.8rem;
}
.investor-header h2 {
  font-size: 2.5rem;
  font-weight: 800;
  margin-top: 10px;
}

.investor-intro-box {
  display: flex;
  align-items: flex-start;
  gap: 25px;
  background: #1a1a1a;
  padding: 35px;
  border-radius: 8px;
  margin-bottom: 50px;
  border: 1px solid #333;
}
.intro-icon {
  width: 45px;
  height: 45px;
  color: #b91c1c;
  flex-shrink: 0;
}
.intro-text h3 {
  margin: 0 0 10px 0;
  font-size: 1.4rem;
  color: #fff;
}
.intro-text p {
  margin: 0;
  font-size: 1.05rem;
  color: #ccc;
  line-height: 1.7;
}

.investor-sections {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  margin-bottom: 60px;
}
.card-head-line {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 25px;
  border-bottom: 1px solid #333;
  padding-bottom: 15px;
}
.h-icon {
  width: 22px;
  height: 22px;
  color: #b91c1c;
}
.card-head-line h3 {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 700;
}

.type-sub-grid {
  display: grid;
  gap: 15px;
}
.type-item {
  background: #1a1a1a;
  padding: 15px;
  border-radius: 4px;
  border-left: 3px solid #b91c1c;
  color: #aaa;
  font-size: 0.95rem;
  line-height: 1.5;
}
.type-item strong {
  color: #fff;
  display: block;
  margin-bottom: 4px;
}

.investor-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.investor-list li {
  color: #aaa;
  position: relative;
  padding-left: 20px;
  line-height: 1.5;
}
.investor-list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 10px;
  width: 6px;
  height: 1px;
  background: #b91c1c;
}

/* Mindset Table Styling */
.mindset-section {
  margin-bottom: 60px;
}
.mindset-section h3 {
  font-size: 1.5rem;
  margin-bottom: 25px;
  text-align: center;
}
.table-wrapper {
  overflow-x: auto;
  background: #1a1a1a;
  border-radius: 8px;
  border: 1px solid #333;
}
.comparison-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}
.comparison-table th {
  background: #222;
  padding: 15px 20px;
  color: #b91c1c;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 1px;
}
.comparison-table td {
  padding: 15px 20px;
  border-top: 1px solid #333;
  color: #ccc;
}

/* Mistakes Styling */
.mistakes-grid {
  background: #1a1a1a;
  padding: 40px;
  border-radius: 8px;
  border: 1px solid #333;
  margin-bottom: 60px;
  text-align: center;
}
.mistakes-header h3 {
  margin-bottom: 30px;
  font-size: 1.5rem;
  color: #fff;
}
.mistakes-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
}
.mistake-tag {
  border: 1px solid #444;
  padding: 8px 18px;
  border-radius: 50px;
  font-size: 0.9rem;
  color: #aaa;
  transition: 0.3s;
}
.mistake-tag:hover {
  border-color: #b91c1c;
  color: #fff;
  background: rgba(185, 28, 28, 0.1);
}

.golden-rule-banner {
  margin-top: 60px;
  text-align: center;
  border: 1px dashed #b91c1c;
  padding: 30px;
  border-radius: 8px;
  background: rgba(185, 28, 28, 0.05);
}
.golden-rule-banner p {
  margin: 0;
  font-size: 1.2rem;
  color: #b91c1c;
  text-transform: uppercase;
  letter-spacing: 1px;
}

@media (max-width: 992px) {
  .investor-sections {
    grid-template-columns: 1fr;
  }
  .investor-intro-box {
    flex-direction: column;
    text-align: center;
  }
  .mistake-tag {
    width: 100%;
  }
}
</style>
